<template>
	<div>
		<v-list dense>
			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>
						{{ $t("label.created_at") }}: {{ order.created_at }}
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action-text>
					<v-btn
						color="primary"
						small
						icon
						class="ma-2 white--text"
						:href="
							$route('tenant.order.print', {
								tenant: $page.props.tenant.id,
								order: order.uuid,
							})
						"
						target="_blank"
					>
						<v-icon dark>mdi-printer</v-icon>
					</v-btn>
				</v-list-item-action-text>
			</v-list-item>

			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>
						{{ $t("label.initial") }}
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action-text>
					{{ order.initial }}
				</v-list-item-action-text>
			</v-list-item>
			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>
						{{ $t("Discount") }}
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action-text>
					{{ order.discount }}
				</v-list-item-action-text>
			</v-list-item>
			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>
						{{ $t("Subtotal") }}
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action-text>
					{{ order.subtotal }}
				</v-list-item-action-text>
			</v-list-item>
			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>{{ $t("label.tax") }}</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action-text>
					{{ order.tax }}
				</v-list-item-action-text>
			</v-list-item>
			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>
						{{ $t("Total") }}
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action-text>
					{{ order.total }}
				</v-list-item-action-text>
			</v-list-item>
			<v-list-item v-if="order.available_total">
				<v-list-item-content>
					<v-list-item-title>
						{{ $t("label.available_total") }}
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action-text>
					{{ order.available_total }}
				</v-list-item-action-text>
			</v-list-item>
			<v-list-item v-if="order.available_refund">
				<v-list-item-content>
					<v-list-item-title>
						{{ $t("label.available_refund") }}
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action-text>
					{{ order.available_refund }}
				</v-list-item-action-text>
			</v-list-item>
		</v-list>
	</div>
</template>

<script>
export default {
	props: ["order"],
};
</script>